/**
 * Generates a validation message for the start date field based on the validation errors.
 * @param {*} startDate - The start date field object containing validation error information.
 * @returns {string} - The appropriate validation message based on the error type, or an empty string if there are no errors.
 */
export function startDateValidationMessage(startDate) {
    if (startDate.$error) {
        if (!startDate.required) {
            return `Enter Start Date`;
        } else if (!startDate.isExpired) {
            return "Rate Expired";
        } else if (!startDate.isSameOrAfter) {
            return "Must not be less than last date";
        } else if (!startDate.customValidator) {
            return "Must be after the current date";
        } else {
            return "Invalid Date";
        }
    }
    return "";
}

/**
 * Generates a validation message for the end date field based on the validation errors.
 * @param {*} endDate - The end date field object containing validation error information.
 * @returns {string} - The appropriate validation message based on the error type, or an empty string if there are no errors.
 */
export function endDateValidationMessage(endDate) {
    if (endDate.$error) {
        if (!endDate.required) {
            return `Enter End Date`;
        } else if (!endDate.isExpired) {
            return "Rate Expired";
        } else if (!endDate.customValidator) {
            return "Must be later than start date";
        } else if (!endDate.mustBeAfterNow) {
            return "Must be later than current date";
        } else {
            return "Invalid Date";
        }
    }
    return "";
}

/**
 * Generates a validation message for a generic attribute based on the validation errors.
 * @param {*} attribute - The attribute field object containing validation error information.
 * @param {string} key - The name of the attribute to be used in the validation message.
 * @returns {string} - The appropriate validation message based on the error type, or an empty string if there are no errors.
 */
export function generateValidationMessage(attribute, key) {
    if (attribute.$error) {
        if (!attribute.required) {
            return `Enter a ${key}.`;
        } else if (!attribute.minValue) {
            return "Enter a value greater than 0";
        } else if (!attribute.decimal) {
            return "It must be numerical";
        } else if (!attribute.numeric) {
            return "It must be numerical";
        }
    }
    return "";
}

/**
 * Generates a validation message for the maximum hours field based on the validation errors.
 * @param {*} attribute - The maximum hours field object containing validation error information.
 * @returns {string} - The appropriate validation message based on the error type, or an empty string if there are no errors.
 */
export function maximunHoursValidationMessage(attribute) {
    if (attribute.$error) {
        if (!attribute.required) {
            return `Enter a maximum hours.`;
        } else if (!attribute.minValue) {
            return `Enter a value greater than ${attribute.$params.minValue.min}`;
        } else if (!attribute.maxValue) {
            return `Enter a value less than ${attribute.$params.maxValue.max}`;
        } else if (!attribute.decimal) {
            return "It must be numerical";
        } else if (!attribute.numeric) {
            return "It must be numerical";
        }
    }
    return "";
}

/**
 * Generates a validation message for the minimum hours field based on the validation errors.
 * @param {*} attribute - The minimum hours field object containing validation error information.
 * @returns {string} - The appropriate validation message based on the error type, or an empty string if there are no errors.
 */
export function minimumHoursValidationMessage(attribute) {
    if (attribute.$error) {
        if (!attribute.required) {
            return `Enter a minimum hours.`;
        } else if (!attribute.minValue) {
            return `Enter a value greater than ${attribute.$params.minValue.min}`;
        } else if (!attribute.maxValue) {
            return `Enter a value less than ${attribute.$params.maxValue.max}`;
        } else if (!attribute.decimal) {
            return "It must be numerical";
        } else if (!attribute.numeric) {
            return "It must be numerical";
        }
    }
    return "";
}